import { useCallback, useState } from 'react';

import type { Question, QuestionnaireAnswers } from '@shared';

interface UseShortTextQuestionOptions {
  question: Question;
  initialValue: string;
  onSubmit: (patch: Partial<QuestionnaireAnswers>) => Promise<void> | void;
}

export interface ShortTextQuestionState {
  value: string;
  setValue: (next: string) => void;
  isValid: boolean;
  submit: () => Promise<void>;
}

export function useShortTextQuestion({
  question,
  initialValue,
  onSubmit,
}: UseShortTextQuestionOptions): ShortTextQuestionState {
  const [value, setValue] = useState<string>(initialValue);
  const isValid = value.trim().length > 0;

  const submit = useCallback(async () => {
    if (!isValid) return;

    await onSubmit({ [question.id]: value.trim() } as Partial<QuestionnaireAnswers>);
  }, [isValid, question.id, value, onSubmit]);

  return { value, setValue, isValid, submit };
}
